<template>
  <div id="home-view">
    <h1>Accueil</h1>
    <v-container id="grid" fluid grid-list-sm tag="section">
      <v-layout row wrap>
        <v-flex d-flex xs12 order-xs5 v-if="applicationNumber">
          <v-alert
            style="cursor: pointer;"
            :value="true"
            type="info"
            @click="$router.push('/applications')"
          >
            Il y a
            <b>{{applicationNumber}}</b> nouvelles candidatures à traiter depuis votre dernière connexion.
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'home-view',
  created() {
    this.$store.dispatch('moduleApplications/getApplications')
  },
  computed: {
    applicationNumber() { return this.$store.getters['moduleUser/userIsResponsible'] ? this.$store.getters['moduleApplications/getResponsibleNewApplications'].length : this.$store.getters['moduleApplications/getFormateurNewApplications'].length }
  }
}
</script>
